import React, { useState } from 'react';

function StepFive({ formData, onNext }) {
    const [hadHospitalVisit, setHadHospitalVisit] = useState(formData.hadHospitalVisit || '');
    const [hospitalDetails, setHospitalDetails] = useState(formData.hospitalDetails || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!hadHospitalVisit) {
            setError('Please select Yes or No.');
            return;
        }

        if (hadHospitalVisit === 'yes' && !hospitalDetails.trim()) {
            setError('Please provide details about your hospital admission or surgery.');
            return;
        }

        setError('');
        onNext({ hadHospitalVisit, hospitalDetails });
    };

    const isFormValid =
        hadHospitalVisit === 'no' ||
        (hadHospitalVisit === 'yes' && hospitalDetails.trim());

    return (
        <div className="step-form">
            <h6 className="mb-4">General Health</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <p>Have you ever been admitted to hospital or had surgery? <span className="text-danger">*</span></p>
            <div className="row">
                <div className="col-lg-6">
                    <div className="form-check mb-2">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="hospitalVisit"
                            id="hospitalYes"
                            value="yes"
                            checked={hadHospitalVisit === 'yes'}
                            onChange={() => setHadHospitalVisit('yes')}
                        />
                        <label className="form-check-label" htmlFor="hospitalYes">
                            Yes
                        </label>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="form-check mb-3">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="hospitalVisit"
                            id="hospitalNo"
                            value="no"
                            checked={hadHospitalVisit === 'no'}
                            onChange={() => setHadHospitalVisit('no')}
                        />
                        <label className="form-check-label" htmlFor="hospitalNo">
                            No
                        </label>
                    </div>
                </div>
            </div>

            {hadHospitalVisit === 'yes' && (
                <div className="mb-3">
                    <label className="form-label">Please provide details:</label>
                    <textarea
                        className="form-control"
                        placeholder="Please provide details"
                        rows="4"
                        value={hospitalDetails}
                        onChange={e => setHospitalDetails(e.target.value)}
                    />
                </div>
            )}

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!isFormValid}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default StepFive;
